var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-col',{staticClass:"py-0 pl-0",attrs:{"sm":"12"}},[_c('ContentInput',{attrs:{"title":"","model":"description","subtitle":"Maximum 100.000 characters"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }